<template>
  <v-btn @click="onClick" :disabled="!disabled" small>
    <v-icon small>refresh</v-icon>
    <span style="padding-left: 5px">クリエイティブ一覧を更新</span>
  </v-btn>
</template>

<script>
export default {
  name: 'CampaignModalPageCreativeRefreshCreativePage',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick() {
      this.$emit('onClick')
    },
  },
}
</script>
